import React from 'react'
import { ProductBuilderState } from '../state'
import IconButton from '@material-ui/core/IconButton'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Close from '@material-ui/icons/Close'
import { connect } from 'react-redux'

const productBuilderNotificationsView = (props: ProductBuilderState) => {
    const notificationIndex = props.notifications.findIndex(it => !it.closed)
    if (notificationIndex === -1) return null
    const notification = props.notifications[notificationIndex]
    return <Card className='notification-card'>
        <CardHeader
            title={notification.title}
            action={<IconButton 
                aria-label="close" 
                onClick={() => props.dispatch({ type: 'PRODUCT_BUILDER_NOTIFICATION_VISIBILITY_SET', params: { notificationIndex, visible: false } })}
                ><Close fontSize="small" /></IconButton>} />
        <CardContent>
            <div dangerouslySetInnerHTML={{ __html: notification.content }}></div>
        </CardContent>
    </Card>
}

export const ProductBuilderNotificationsView =
    connect((state: any) => state.productBuilderState)(productBuilderNotificationsView)